export class ChooseMechanismService {
    /* @ngInject */
    constructor(
        $http,
        $log,
        $cookies,
        $state,
        $window,
        $q,
        $timeout,
        egUrlService,
        errorService
    ) {
        this.$http = $http;
        this.$log = $log;
        this.$cookies = $cookies;
        this.$state = $state;
        this.$window = $window;
        this.$timeout = $timeout;
        this.$q = $q;
        this.egUrlService = egUrlService;
        this.errorService = errorService;
    }

    query() {
        let url =  this.egUrlService.url('/authentication/chosenAuthenticationMechanisms');
        return this.$http.get(url)
            .then(response => {return response.data;},
                    response => {return this.$q.reject(response.data);});
    }

    choose(mechanism, wasAlreadyChosen) {
        let url = this.egUrlService.url('/authentication/chosenAuthenticationMechanisms/choose?id={{id}}', {
            id: mechanism.id
        });
        this.$http.post(url).then(() => {
            this._requestSuccess(mechanism);
        }, response => {
            this._requestError(response);
        });
    }

    _requestSuccess(mechanism) {

        this.errorService.clearError();

        switch (mechanism.authenticationMechanism.type) {
            case 'PASSWORD_CREDENTIALS':
                this.$state.go('login');
                break;
            case 'SAML':
                let samlRedirectUrl = this.egUrlService.url('/saml/login/alias/{{alias}}?idp={{idpEntityId}}', {
                    alias: mechanism.authenticationMechanism.alias,
                    idpEntityId: mechanism.authenticationMechanism.idpEntityId
                });
                this.$timeout(() => {
                    this.$window.location.href = samlRedirectUrl;
                }, 250);
                break;
            case 'OAUTH':
                // TODO KARSI: Redirect to OAuth login page.
                break;
        }
    }

    _requestError(response) {
        return this.$q.reject(response.data);
    }

    redirectToFormLogin(){
        this.$state.go('login');
    }

    redirectChooseMechanism(){
        this.$state.go('chooseMechanism.list');
    }

    redirectToSingleMechanism(){
        this.$state.go('chooseMechanism');
    }
}
